import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async list(params) {
        return to(Http.get(window.API_PREFIX + "/departments", {params}))
    },
    async get(id) {
        return to(Http.get(window.API_PREFIX + `/departments/${id}`))
    },
    async getSelect(params = {}) {
        return this.list({_type: "select", ...params})
    },
    async create(data) {
        return to(Http.post(window.API_PREFIX + `/departments`, data))
    },
    async insert(data) {
        return to(Http.post(window.API_PREFIX + `/departments`, data))
    },
    async update(id, data) {
        return to(Http.post(window.API_PREFIX + `/departments/${id}`, {'_method' : 'patch', ...data}))
    },
    async save(data, id) {
        return id ? this.update(id, data) : this.insert(data)
    },
    async delete(id) {
        return to(Http.post(window.API_PREFIX + `/departments/${id}`, {'_method': 'delete'}))
    }
}

